import { useEffect } from "react";

/**
 * Lightweight SEO helper — sets document.title and core meta tags via DOM.
 * Avoids react-helmet dependency.
 */
export default function SEO({ title, description, image, path }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(selector.startsWith("meta") ? "meta" : "link");
        const [, k, v] = selector.match(/\[(.+?)=["'](.+?)["']\]/) || [];
        if (k && v) el.setAttribute(k, v);
        document.head.appendChild(el);
      }
      if (value != null) el.setAttribute(attr, value);
    };
    if (description) {
      set('meta[name="description"]', "content", description);
      set('meta[property="og:description"]', "content", description);
      set('meta[name="twitter:description"]', "content", description);
    }
    if (title) {
      set('meta[property="og:title"]', "content", title);
      set('meta[name="twitter:title"]', "content", title);
    }
    if (image) {
      set('meta[property="og:image"]', "content", image);
      set('meta[name="twitter:image"]', "content", image);
    }
    set('meta[property="og:type"]', "content", "website");
    set('meta[name="twitter:card"]', "content", "summary_large_image");
    if (path) {
      const url = `${window.location.origin}${path}`;
      set('meta[property="og:url"]', "content", url);
      set('link[rel="canonical"]', "href", url);
    }
  }, [title, description, image, path]);
  return null;
}
